import React from 'react';
import WorkshopHubComponent from '../../components/proStudent/WorkshopHub/WorkshopHub';

const WorkshopHub = () => {
  return <WorkshopHubComponent />;
};

export default WorkshopHub;
